import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "right-bar-error",
  title: "Необходимо скорректировать ФРВ сотрудника"
}
const _hoisted_2 = { class: "time-count__all" }
const _hoisted_3 = { class: "time-count__actual" }
const _hoisted_4 = { class: "time-count__proc" }
const _hoisted_5 = { class: "time-count__planned" }
const _hoisted_6 = { class: "time-count__proc" }
const _hoisted_7 = {
  key: 0,
  class: "time-count__all"
}

import {computed} from "vue";
import {NewUser} from "@/types";
import {useStore} from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaRightBar',
  setup(__props) {

const store = useStore()

const users = computed<NewUser[]>(() => {
  return store.getters['data/pharmUsers']
})

const holidaysCount = computed<number>(() => {
  return store.getters['data/holidays'] && store.getters['data/holidays'].length
})

const calculate = (norm:number ,col:number): number => {
  if (norm) {
    const oneProc = norm / 100
    return +(col / oneProc).toFixed(1)
  } else {
    return 0
  }
}

const formatNumber = (planned = 0, actual = 0): string => {
  let str = (planned + actual).toFixed(2);

  if (str.includes('.')) {
    while (str.endsWith('0')) {
      str = str.slice(0, -1);
    }
    if (str.endsWith('.')) {
      str = str.slice(0, -1);
    }
  }

  return str;
}

const colorIndicator = (norm:number ,col: number): string => {
  if (norm === 0) {
    return 'grey'
  }

  if (col < norm) {
    return 'orange'
  } else if (col === norm) {
    return 'green'
  } else if (col > norm) {
    return 'red'
  } else {
    return 'grey'
  }
}

// Проверка на превышение выделенного ФРВ
const checkingNumbersVS = [2, 630, 24, 15, 6, 1221, 2051, 2092, 741]
const hasExcessFRV = (user: NewUser) => {
  if (!user.frv || !user.numberVs) return

  if ((user.frv.frvSchedule > user.frv.frvNorm) && checkingNumbersVS.includes(user.numberVs)) return true
}

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
    return (_openBlock(), _createElementBlock("div", {
      key: user.zupGuid,
      class: _normalizeClass(["right-bar__time-count", {'has-fv': holidaysCount.value > 0, 'has-error' : hasExcessFRV(user)}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_vita_icon, { name: "warn-circle-red" })
      ]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(user.frv?.frvNorm ?? 0) + " ч", 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["indicator", [colorIndicator((user.frv?.frvNorm ?? NaN), (user.frv?.frvFact ?? NaN))]])
        }, null, 2),
        _createTextVNode(_toDisplayString(user.frv?.frvFact ?? 0) + " ч ", 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(calculate((user.frv?.frvNorm ?? 0), (user.frv?.frvFact ?? 0))) + " %", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(["indicator", [colorIndicator((user.frv?.frvNorm ?? NaN), (user.frv?.frvSchedule ?? NaN))]])
        }, null, 2),
        _createTextVNode(_toDisplayString(formatNumber((user.frv?.frvSchedule ?? 0) +  (user.frv?.frvNew ?? 0))) + " ч ", 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(calculate((user.frv?.frvNorm ?? 0), (user.frv?.frvSchedule ?? 0) + (user.frv?.frvNew ?? 0))) + " %", 1)
      ]),
      (holidaysCount.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", null, "РВ: " + _toDisplayString((user.frv?.frvFactRv ?? 0)) + " ч / " + _toDisplayString(formatNumber(user.frv?.frvRvSchedule, user.frv?.frvRvNew)) + " ч", 1)
          ]))
        : _createCommentVNode("", true)
    ], 2))
  }), 128))
}
}

})